// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__31Mwi","title":"Images90_title__3H6rR","images":"Images90_images__3bHWT"};